import { useMapEvents } from "react-leaflet";
import { useAlert } from "../../contexts/AlertContext";

export default function ClickHandler({ onMove, bounds }) {
  const { showAlert } = useAlert();
  useMapEvents({
    click(e) {
      if (
        e.latlng.lat < bounds[0][0] ||
        e.latlng.lat > bounds[1][0] ||
        e.latlng.lng < bounds[0][1] ||
        e.latlng.lng > bounds[1][1]
      ) {
        showAlert("Location is out of bounds!");
        return;
      }
      onMove(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}
